import React from "react";
import PageTitle from "@cs/components/src/PageTitle";
import Button from "@cs/components/src/Button";
import Table from "@cs/components/src/Table";
import Section from "@cs/components/src/Section";
import Spinner from "@cs/components/src/Spinner";
import { PageWrapper } from "@cs/components/src/PageWrapper";
import { Plus } from "react-feather";
import { useQuery } from "react-query";
import ApiService from "../../services/ApiService";
import styled from "styled-components";

const EmailList = styled.span`
  color: var(--gray300);
  font-size: 13px;
`;

const UserListScreen = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["userList"],
    queryFn: async (): Promise<AppUser[]> => {
      const response = await ApiService.fetch<{ data: AppUser[] }>(
        "GET",
        `/api/users`
      );
      return response.data;
    },
  });

  return (
    <div>
      <PageTitle
        title="Users"
        error={isError ? "Problem loading users" : undefined}
      >
        <Button
          label="Add User"
          icon={Plus}
          link="/config/user/new"
          type="success"
        />
      </PageTitle>

      {isLoading ? (
        <Spinner />
      ) : (
        !isError && (
          <PageWrapper>
            <Section>
              <Table
                columnGrid
                columns={[
                  { title: "Slack ID", width: "1fr" },
                  { title: "Emails", width: "3fr" },
                ]}
                rowHeight={40}
                rows={(data ?? []).map((user) => ({
                  id: user.slackId,
                  link: user.slackId,
                  element: () => (
                    <>
                      <div>{user.slackId}</div>
                      <EmailList>{user.emails.join(", ")}</EmailList>
                    </>
                  ),
                }))}
                autoHeight={{}}
              />
            </Section>
          </PageWrapper>
        )
      )}
    </div>
  );
};

export default UserListScreen;
